<div class="grid-container">
    <div *ngFor="let shop of partenrs let i = index" class="grid-item">
        <taly-shop-card [shop]="shop" *ngIf="i < 4" />
    </div>
</div>